// This is an autogenerated file. Do not manually edit.
// Run `node packages/controls/mini-fluent-icons-svg/updateIcons.js` to update the icons in this package
import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling/lib/utilities/icons';

const PersonMailRegular = CreateSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 10c0 1.5 1.09 3.05 3 3.69v-1.07c-1.3-.55-2-1.61-2-2.62v-.5c0-.28.22-.5.5-.5H5c0-.36.1-.7.27-1H3.5C2.67 8 2 8.67 2 9.5v.5Zm5-8.5A2.75 2.75 0 1 1 7 7a2.75 2.75 0 0 1 0-5.5Zm0 1A1.75 1.75 0 1 0 7 6a1.75 1.75 0 0 0 0-3.5Zm3.51 9.43L6.01 9.3c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43Zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 6 13.5v-3.05l4.25 2.48c.15.09.33.1.49.01Z" />
        </svg>
    ),
    displayName: 'PersonMailRegular',
});

export default 'PersonMailRegular';

registerIcons({
    icons: {
        PersonMailRegular: <PersonMailRegular />,
    },
});
